// extracted by mini-css-extract-plugin
export var menuIcon = "_uj-0";
export var menuIconInline = "_uj-1";